module.exports = __webpack_public_path__ + "static/media/sheet-large.1ece9ae3.svg";